import { ProvisioningStatus } from '../enums/ProvisioningStatus';

export interface IProductInstanceInfo {
  productType: string;
  provisioningStatus?: string;
  [key: string]: any;
}

export interface IRoleWithProductKey {
  productKey?: string;
  [key: string]: any;
}

const SASE_PRODUCT_TYPE = 'sase';
const HIDDEN_PRODUCT_KEYS = ['secure-access', 'sdwan'];

export function shouldHideSaseRoles(
  products: IProductInstanceInfo[] | null | undefined
): boolean {
  if (!products || !Array.isArray(products) || products.length === 0) {
    return false;
  }

  const saseProduct = products.find(
    (product) => product.productType?.toLowerCase() === SASE_PRODUCT_TYPE
  );

  if (!saseProduct) {
    return false;
  }

  return saseProduct.provisioningStatus !== ProvisioningStatus.FINISHED;
}

export function filterRolesBySaseState<T extends IRoleWithProductKey>(
  roles: T[] | null | undefined,
  products: IProductInstanceInfo[] | null | undefined
): T[] {
  if (!roles || !Array.isArray(roles)) {
    return [];
  }

  const hideRoles = shouldHideSaseRoles(products);

  if (!hideRoles) {
    return roles;
  }

  return roles.filter((role) => {
    if (!role.productKey) {
      return true;
    }
    return !HIDDEN_PRODUCT_KEYS.includes(role.productKey);
  });
}
